import CheckboxList from './CheckboxList.jsx';
import { useBookableResourcesQuery, useEventTypesQuery } from '../lib/Queries';
import ErrorMessage from './ErrorMessage';
import { Link } from 'react-router-dom';
import { getBusinessUrl } from '../lib/useBusinessNavigate.js';
import { ObjectTypes } from '~/lib/ObjectTypes.js';
import CustomTags from '~/components/customfields/CustomTags.jsx';

const BookableResourcesCheckboxes = ({ value, onChange, id, className }) => {
    const { data } = useBookableResourcesQuery();

    const options = (data || []).map(type => {
        return {
            label: type.name,
            value: type.id,
            type: type.type,
            custom_fields: type.custom_fields,
        };
    });

    const groupedOptions = {};
    for (const opt of options) {
        groupedOptions[opt.type] = [...(groupedOptions[opt.type] || []), opt];
    }

    const firstKey = Object.keys(groupedOptions)[0];

    return (
        <div className={className}>
            {Object.keys(groupedOptions).map(key => (
                <div key={key}>
                    <div
                        className={`text-sm uppercase text-primary-700 ${firstKey !== key ? 'mt-4' : ''}`}
                    >
                        {key}
                    </div>
                    <CheckboxList
                        value={value}
                        onChange={onChange}
                        options={groupedOptions[key]}
                        renderLabel={({ opt }) => (
                            <div>
                                {opt.label}
                                <CustomTags
                                    type={ObjectTypes.BOOKABLE_RESOURCE}
                                    id={opt.value}
                                    fields={opt.custom_fields}
                                />
                            </div>
                        )}
                        id={id}
                        containerClassName="divide-y"
                    />
                </div>
            ))}

            {Object.keys(groupedOptions).length === 0 && (
                <ErrorMessage className="mb-2">
                    There is nothing that can be booked on. Please add a Person
                    or Resource under{' '}
                    <Link to={getBusinessUrl('/scheduling/availability')}>
                        Scheduling &gt; Availability
                    </Link>
                    .
                </ErrorMessage>
            )}
        </div>
    );
};

export default BookableResourcesCheckboxes;
